import styled from 'styled-components';

export const RootAutocomplete = styled.div`
  position: relative;
  width: 100%;
`;

export const MobileSearchContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: #fff;
  .back-icon {
    margin: 20px;
  }
`;

export const BorderWrapper = styled.div`
  box-shadow: 0px 8px 20px 2px rgba(0, 0, 0, 0.12);
  padding: 2rem 2rem;
  margin: 2rem 0rem;
  border-radius: 16px;
  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;
